import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export default {
  state: {
    company: {
      logo: '',
      tradingName: '',
      document: '',
      phone: '',
      email: '',
      description: '',
      site: '',
      zipCode: '',
      address: '',
      addressNumber: '',
      complement: '',
      neighborhood: '',
      state: '',
      city: '',
      categories: '',
      needSchedule: false,
      customTime: false,
      weekDayStart: '',
      weekDayEnd: '',
      weekDayInterval: '',
      weekDayCapacity: 0,
      sundayStart: '',
      sundayEnd: '',
      sundayInterval: '',
      sundayCapacity: 0,
      mondayStart: '',
      mondayEnd: '',
      mondayInterval: '',
      mondayCapacity: 0,
      tuesdayStart: '',
      tuesdayEnd: '',
      tuesdayInterval: '',
      tuesdayCapacity: 0,
      wednesdayStart: '',
      wednesdayEnd: '',
      wednesdayInterval: '',
      wednesdayCapacity: 0,
      thursdayStart: '',
      thursdayEnd: '',
      thursdayInterval: '',
      thursdayCapacity: 0,
      fridayStart: '',
      fridayEnd: '',
      fridayInterval: '',
      fridayCapacity: 0,
      saturdayStart: '',
      saturdayEnd: '',
      saturdayInterval: '',
      saturdayCapacity: 0
    },
    logoNotSent: '',
    loadingCompany: false,
    loadingZipCode: false,
    waitingApproval: false,
    evaluations: [],
    users: [],
    currentPage: 1,
    totalItems: 0,
    totalPages: 0,
    itemsPerPage: 12,
    paginaInicial: 0,
    paginaFinal: 0,
    userModal: false,
    evaluationModal: false,
    loadingEvaluationAction: false,
    loadingUserAction: false,
    selectedAvaliacao: {
      id: 0,
      data: '',
      usuario: '',
      item: '',
      nota: '',
      comentario: '',
      resposta: ''
    },
    selectedUser: {
      id: 0,
      nome: '',
      login: '',
      telefone: '',
      email: '',
      departamento: '',
      active: true,
      senha: ''
    }
  },
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/empresa/index.js